import FilterByGender from "./FilterByGender.tsx";
import FilterGroup from "./FilterGroup.tsx";
import AgeSelect, {AgeOption} from "./AgeSelect.tsx";
import FilterBySpecies from "./FilterBySpecies.tsx";
import Select, {MultiValue} from "react-select";
import {DropdownIndicator, REACT_SELECT_STYLES} from "../style-constants.tsx";
import ClearableTextInput from "../ClearableTextInput.tsx";

export type PetFilterState = {
  dogFilter: boolean;
  catFilter: boolean;
  critterFilter: boolean;
  maleFilter: boolean;
  femaleFilter: boolean;
  ageFilterValue: MultiValue<AgeOption>;
  breedFilterValue: MultiValue<{ value: string; label: string }>;
  searchTerm: string;
};

export type PetFilterControlsProps = {
  filterState: PetFilterState;
  breedOptions: { value: string; label: string }[];
  setSearchTerm: (value: string) => void;
  handleDogFilterChange: () => void;
  handleCatFilterChange: () => void;
  handleCritterFilterChange: () => void;
  handleMaleFilterChange: () => void;
  handleFemaleFilterChange: () => void;
  handleAgeFilterChange: (value: MultiValue<AgeOption>) => void;
  handleBreedFilterChange: (
    value: MultiValue<{ value: string; label: string }>,
  ) => void;
};

export default function PetFilterControls({
  breedOptions,
  filterState,
  setSearchTerm,
  handleDogFilterChange,
  handleCatFilterChange,
  handleCritterFilterChange,
  handleMaleFilterChange,
  handleFemaleFilterChange,
  handleAgeFilterChange,
  handleBreedFilterChange,
}: PetFilterControlsProps) {
  return (
    <div className="bg-white border border-primary rounded-md mb-4">
      <div className="pt-4">
        <FilterBySpecies
          dogFilter={filterState.dogFilter}
          catFilter={filterState.catFilter}
          critterFilter={filterState.critterFilter}
          handleDogFilterChange={handleDogFilterChange}
          handleCatFilterChange={handleCatFilterChange}
          handleCritterFilterChange={handleCritterFilterChange}
        />
      </div>

      <div className="flex flex-col md:flex-row gap-4 mx-auto p-8">
        <FilterByGender
          maleFilter={filterState.maleFilter}
          femaleFilter={filterState.femaleFilter}
          handleMaleFilterChange={handleMaleFilterChange}
          handleFemaleFilterChange={handleFemaleFilterChange}
        />

        <div className="flex-grow w-full md:w-[200px] max-w-[300px]">
          <FilterGroup
            label={"Age"}
            control={
              <AgeSelect
                value={filterState.ageFilterValue}
                onChange={handleAgeFilterChange}
              />
            }
          />
        </div>

        <div className="flex-grow w-full md:w-[200px] max-w-[300px]">
          <FilterGroup
            label={"Looks Like"}
            control={
              <Select
                styles={REACT_SELECT_STYLES}
                components={{ DropdownIndicator }}
                menuPortalTarget={document.body}
                isMulti={true}
                value={filterState.breedFilterValue}
                options={breedOptions}
                onChange={handleBreedFilterChange}
                placeholder="All breeds"
              />
            }
          />
        </div>

        <FilterGroup
          label={"Name"}
          control={
            <ClearableTextInput
              placeholder="Search by pet's name"
              value={filterState.searchTerm}
              onChange={(value) => setSearchTerm(value)}
            />
          }
        />
      </div>
    </div>
  );
}
